import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'
import esES from './locales/es-ES'
import arSA from './locales/ar-SA'
import jaJP from './locales/ja-JP'

// 获取初始语言
function getInitialLanguage() {
  // 优先使用用户手动设置的语言
  const userLanguage = localStorage.getItem('selected-language')
  if (userLanguage && ['zh-CN', 'en-US', 'es-ES', 'ar-SA', 'ja-JP'].includes(userLanguage)) {
    return userLanguage
  }
  
  // 其次使用浏览器语言
  const browserLanguage = navigator.language
  if (browserLanguage.startsWith('zh')) {
    return 'zh-CN'
  } else if (browserLanguage.startsWith('es')) {
    return 'es-ES'
  } else if (browserLanguage.startsWith('ar')) {
    return 'ar-SA'
  } else if (browserLanguage.startsWith('ja')) {
    return 'ja-JP'
  }
  return 'en-US' // 默认英语
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getInitialLanguage(), // 设置初始语言
  fallbackLocale: 'en-US', // 设置备用语言
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'es-ES': esES,
    'ar-SA': arSA,
    'ja-JP': jaJP
  }
})

// 切换语言的方法
export function setLanguage(locale) {
  if (!['zh-CN', 'en-US', 'es-ES', 'ar-SA', 'ja-JP'].includes(locale)) {
    console.warn(`Unsupported language: ${locale}`)
    return
  }
  
  i18n.global.locale.value = locale
  localStorage.setItem('selected-language', locale)
  
  // 更新HTML标签的lang属性
  const langMap = {
    'zh-CN': 'zh',
    'en-US': 'en',
    'es-ES': 'es',
    'ar-SA': 'ar',
    'ja-JP': 'ja'
  }
  document.documentElement.lang = langMap[locale] || 'en'
}

// 初始化时设置HTML lang属性
const currentLocale = i18n.global.locale.value
const langMap = {
  'zh-CN': 'zh',
  'en-US': 'en',
  'es-ES': 'es',
  'ar-SA': 'ar',
}
document.documentElement.lang = langMap[currentLocale] || 'en'

export default i18n